module.exports = require('../_components/@alicd/next-locale-provider/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/locale-provider/index.js
// module id = 19
// module chunks = 0